export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tipo de endereço"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tipo de conta"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Moeda"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nome"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Criar endereço"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Criar conta"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Criar novo endereço"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Criar nova conta"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Digite o nome"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Selecione a moeda"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Criar"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancelar"])},
  "13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Selecione o tipo"])}
}